// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__bYV5S"};